import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-color: ", ";\n\tborder-width: 0 0 1px 0;\n\theight: 0;\n\tmargin: 0;\n\twidth: auto;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, ui } from '@wp-g2/styles';
export var Divider = css(_templateObject(), ui.get('colorDivider'));